import React, { useState } from "react";
import { TabBar, StatusBanner } from "./scraper";

const CampaignPreviewModal = ({
    isOpen,
    onClose,
    loading,
    data
}) => {
    const [activeTab, setActiveTab] = useState("emails");

    if (!isOpen) {
        return null;
    }

    const tabs = [
        {
            id: "emails",
            label: `📧 Emails (${data?.email_count || 0})`
        },
        {
            id: "phones",
            label: `📱 Phones (${data?.phone_count || 0})`
        },
        {
            id: "instagram",
            label: `📸 Instagram (${data?.instagram_count || 0})`
        }
    ];

    let records = [];

    if (activeTab === "emails") {
        records = data?.emails || [];
    }

    if (activeTab === "phones") {
        records = data?.phones || [];
    }

    if (activeTab === "instagram") {
        records = data?.instagrams || [];
    }

    return (
        <div
            className="
                fixed
                inset-0
                bg-black/50
                flex
                items-center
                justify-center
                z-50
            "
        >
            <div
                className="
                    bg-white
                    rounded-2xl
                    shadow-xl
                    w-full
                    max-w-4xl
                    p-6
                    max-h-[90vh]
                    overflow-y-auto
                "
            >

                <div
                    className="
                        flex
                        justify-between
                        items-center
                        mb-4
                    "
                >
                    <h2
                        className="
                            text-xl
                            font-semibold
                        "
                    >
                        {data?.campaign_name}
                    </h2>

                    <button
                        onClick={onClose}
                        className="
                            text-gray-500
                            hover:text-gray-700
                        "
                    >
                        ✕
                    </button>
                </div>

                {loading ? (

                    <div>
                        Loading...
                    </div>

                ) : (

                    <>

                        <TabBar
                            tabs={tabs}
                            active={activeTab}
                            onChange={setActiveTab}
                        />

                        {records.length === 0 ? (

                            <StatusBanner type="info">
                                No records found for this tab.
                            </StatusBanner>

                        ) : (

                            <div
                                className="
                border
                rounded-xl
                overflow-hidden
            "
                            >

                                <div
                                    className="
                    max-h-[450px]
                    overflow-y-auto
                "
                                >

                                    {records.map(
                                        (item, index) => (
                                            <div
                                                key={index}
                                                className="
                                px-4
                                py-3
                                border-b
                                text-sm
                                hover:bg-gray-50
                            "
                                            >
                                                {item}
                                            </div>
                                        )
                                    )}

                                </div>

                            </div>

                        )}

                    </>
                )}

            </div>
        </div>
    );
};

export default CampaignPreviewModal;